<script>
import TextInput from "@/components/TextInput";
import ModifyButtons from "@/components/ModifyButtons";
import ErrorMessage from "@/components/ErrorMessage";
import features from "@/configs/features";
import bus from "@/bus";
import { useResourcesStore } from "../../stores/resources";

export default {
  setup() {
    const resourcesStore = useResourcesStore();
    return { resourcesStore };
  },
  components: {
    TextInput,
    ModifyButtons,
    ErrorMessage,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      town: this.params.town,
      ...(features.DEPART ? { departement: this.params.departement } : {}),
      id: this.params.id,
      errors: [],
    };
  },
  computed: {
    features: () => features,
  },
  methods: {
    closeMessage(id) {
      Object.keys(this.errors).forEach((key) => {
        if (id === this.errors[key].id) {
          this.errors.splice(key, 1);
        }
      });
    },
    async modify() {
      const { town, departement, id } = this;

      const error = await this.resourcesStore.updateTown({
        id,
        data: {
          town,
          departement,
        },
      });
      if (error) {
        this.errors.push({
          id: Date.now(),
          message: error.data.message,
        });
      } else {
        this.close();
      }
    },
    close() {
      bus.emit("closeModal");
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded sm:min-w-md sm:max-w-md">
    <header class="text-gray-700 text-xl font-bold pb-5">
      <span>{{ $t("views.modals.modify_town.edit") }}</span>
    </header>

    <div v-for="msg in errors" :key="msg.id">
      <ErrorMessage :value="msg" @input="closeMessage" />
    </div>

    <TextInput id="town" v-model="town" data-cy="town" :label="$t('views.modals.modify_town.commune')" type="text"
      class="mb-4" />
    <TextInput v-if="features.DEPART" id="departement" v-model="departement" data-cy="departement"
      :label="$t('views.modals.modify_town.departement')" type="text" class="mb-4" />
    <ModifyButtons :candelete="false" @modify="modify" @close="close" />
  </div>
</template>
